import { useMemo } from "react";

interface IUseDateTimeStepEmptyStateProps {
  isLoading: boolean;
  studioHoursLoading: boolean;
  isBulkLoading: boolean;
  hasStudioHours: boolean;
  bulkAvailabilityHasData: boolean;
  hasAnyAvailableSlots: () => boolean;
}

interface IDateTimeStepEmptyState {
  showLoading: boolean;
  showNoStudioHours: boolean;
  showNoAvailability: boolean;
}

/**
 * Decides which non-content state the date/time selection step should render.
 * The three flags are mutually exclusive; if all are false the step renders
 * its normal calendar + time-slots content.
 */
export const useDateTimeStepEmptyState = ({
  isLoading,
  studioHoursLoading,
  isBulkLoading,
  hasStudioHours,
  bulkAvailabilityHasData,
  hasAnyAvailableSlots,
}: IUseDateTimeStepEmptyStateProps): IDateTimeStepEmptyState => {
  return useMemo(() => {
    const showLoading = isLoading || isBulkLoading || studioHoursLoading;

    if (showLoading) {
      return {
        showLoading: true,
        showNoStudioHours: false,
        showNoAvailability: false,
      };
    }

    if (!hasStudioHours) {
      return {
        showLoading: false,
        showNoStudioHours: true,
        showNoAvailability: false,
      };
    }

    const showNoAvailability =
      bulkAvailabilityHasData && !hasAnyAvailableSlots();

    return {
      showLoading: false,
      showNoStudioHours: false,
      showNoAvailability,
    };
  }, [
    isLoading,
    studioHoursLoading,
    isBulkLoading,
    hasStudioHours,
    bulkAvailabilityHasData,
    hasAnyAvailableSlots,
  ]);
};
